if (document.querySelectorAll(".team-slider").length) {
  const team_slider = tns({
    container: ".team-slider",
    loop: true,
    items: 12,
    gutter: 2,
    nav: false,
    autoplay: true,
    autoplayHoverPause: false,
    autoplayButtonOutput: false,
    speed: 4500,
    autoplayTimeout: 0,
    preventActionWhenRunning: true,
    mouseDrag: false,
    controls: false,
    responsive: {
      320: {
        items: 4,
      },
      768: {
        items: 8,
      },
      1024: {
        items: 12,
      },
    },
  });
}

if (document.querySelectorAll(".products-on-sale-slider").length) {
  const products_on_sale_slider = tns({
    container: ".products-on-sale-slider",
    loop: true,
    items: 4,
    nav: false,
    autoplay: false,
    autoplayHoverPause: true,
    autoplayButtonOutput: false,
    speed: 1000,
    preventActionWhenRunning: true,
    controls: true,
    prevButton: ".prev_arrow",
    nextButton: ".next_arrow",
    responsive: {
      320: {
        items: 2,
      },
      768: {
        items: 3,
      },
      1024: {
        items: 4,
      },
    },
  });
}

// if (document.querySelectorAll('.all-products-slider').length) {
//     const all_products_slider = tns({
//         container: '.all-products-slider',
//         loop: true,
//         items: 4,
//         nav: false,
//         autoplay: false,
//         autoplayHoverPause: true,
//         autoplayButtonOutput: false,
//         speed: 1000,
//         preventActionWhenRunning: true,
//         controls: true,
//         prevButton: ".all_prev_arrow",
//         nextButton: ".all_next_arrow",
//         responsive: {
//             320: {
//                 items: 2
//             },
//             768: {
//                 items: 3
//             },
//             1024: {
//                 items: 4
//             }
//         }
//     });
// }

// if (document.querySelectorAll('.jerseys-products-slider').length) {
//     const jerseys_products_slider = tns({
//         container: '.jerseys-products-slider',
//         loop: true,
//         items: 4,
//         nav: false,
//         autoplay: false,
//         autoplayHoverPause: true,
//         autoplayButtonOutput: false,
//         speed: 1000,
//         preventActionWhenRunning: true,
//         controls: true,
//         prevButton: ".jerseys_prev_arrow",
//         nextButton: ".jerseys_next_arrow",
//         responsive: {
//             320: {
//                 items: 2
//             },
//             768: {
//                 items: 3
//             },
//             1024: {
//                 items: 4
//             }
//         }
//     });
// }

// if (document.querySelectorAll('.hardware-products-slider').length) {
//     const hardware_products_slider = tns({
//         container: '.hardware-products-slider',
//         loop: true,
//         items: 4,
//         nav: false,
//         autoplay: false,
//         autoplayHoverPause: true,
//         autoplayButtonOutput: false,
//         speed: 1000,
//         preventActionWhenRunning: true,
//         controls: true,
//         prevButton: ".hardware_prev_arrow",
//         nextButton: ".hardware_next_arrow",
//         responsive: {
//             320: {
//                 items: 2
//             },
//             425: {
//                 items: 2
//             },
//             768: {
//                 items: 3
//             },
//             1024: {
//                 items: 4
//             }
//         }
//     });
// }


for (const bf_slider of document.getElementsByClassName('bf-slider')) {
    var handle = bf_slider.dataset.handle;
    if (document.querySelectorAll('.' + handle + '-bf-slider').length) {
        const handle_products_slider = tns({
            container: '.' + handle + '-bf-slider',
            loop: true,
            items: 3,
            nav: false,
            autoplay: false,
            autoplayHoverPause: true,
            autoplayButtonOutput: false,
            speed: 1000,
            preventActionWhenRunning: true,
            controls: true,
            prevButton: "." + handle + "_prev_arrow",
            nextButton: "." + handle + "_next_arrow",
            responsive: {
                320: {
                    items: 3
                },
                768: {
                    items: 3
                },
                1024: {
                    items: 3
                }
            }
        });
    }
}
      
for (const slider of document.getElementsByClassName('custom-slider')) {
    var handle = slider.dataset.handle;
    console.log(handle);
    if (document.querySelectorAll('.' + handle + '-products-slider').length) {
        const handle_products_slider = tns({
            container: '.' + handle + '-products-slider',
            loop: true,
            items: 4,
            nav: false,
            autoplay: false,
            autoplayHoverPause: true,
            autoplayButtonOutput: false,
            speed: 1000,
            preventActionWhenRunning: true,
            controls: true,
            prevButton: "." + handle + "_prev_arrow",
            nextButton: "." + handle + "_next_arrow",
            responsive: {
                320: {
                    items: 2
                },
                768: {
                    items: 3
                },
                1024: {
                    items: 4
                }
            }
        });
    }
}

if (document.querySelectorAll(".cloud9-slider").length) {
  const cloud9_products_slider = tns({
    container: ".cloud9-slider",
    loop: true,
    items: 3,
    nav: false,
    autoplay: false,
    autoplayHoverPause: true,
    autoplayButtonOutput: false,
    speed: 1000,
    preventActionWhenRunning: true,
    controls: true,
    prevButton: ".cloud_prev_arrow",
    nextButton: ".cloud_next_arrow",
    responsive: {
      320: {
        items: 2,
      },
      768: {
        items: 2,
      },
      1024: {
        items: 3,
      },
    },
  });
}

document.addEventListener("recommended-products:loaded", function () {
  const product_recommend_prev = document.querySelector(
    ".product-recommendations_prev_arrow"
  );
  const product_recommend_next = document.querySelector(
    ".product-recommendations_next_arrow"
  );

  const product_recommendations_slider = tns({
    container: ".product-recommendations__slider",
    loop: true,
    items: 4,
    nav: false,
    autoplay: false,
    autoplayHoverPause: true,
    autoplayButtonOutput: false,
    speed: 1000,
    mouseDrag: true,
    preventActionWhenRunning: true,
    controls: true,
    prevButton: product_recommend_prev,
    nextButton: product_recommend_next,
    responsive: {
      320: {
        items: 2,
      },
      768: {
        items: 2,
      },
      1024: {
        items: 4,
      },
    },
  });
});

/*
if (document.querySelectorAll('.products-recommended-slider').length) {
    const product_recommendations_slider = tns({
        container: '.products-recommended-slider',
        loop: true,
        items: 4,
        nav: false,
        autoplay: false,
        autoplayHoverPause: true,
        autoplayButtonOutput: false,
        speed: 1000,
        preventActionWhenRunning: true,
        controls: false,
        responsive: {
            320: {
                items: 2
            },
            768: {
                items: 3
            },
            1024: {
                items: 4
            }
        }
    });
}
*/


if (document.querySelectorAll('.featured-collection-grid--standard').length) {
  // Function to check the screen size and hide/show the last grid__item
  function checkScreenSize() {
    var screenWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    var collectionGrid = document.querySelector(".featured-collection-grid");
    var gridItems = collectionGrid.getElementsByClassName("grid__item");
    var lastGridItem = gridItems[gridItems.length - 1]; // Get the last grid__item

    if (screenWidth > 768) {
      lastGridItem.style.display = "block"; // Hide the last grid__item
    } else {
      lastGridItem.style.display = "none"; // Show the last grid__item
    }
  }

  // Check the screen size on page load
  window.addEventListener("load", checkScreenSize);

  // Check the screen size on window resize
  window.addEventListener("resize", checkScreenSize);
}
